import { Theme, darken, lighten, makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import ListItemLink from '../../../../ui/Link/ListItemLink';
import Typography from '@material-ui/core/Typography';
import * as Api from '../../../Api';

const useStyles = makeStyles((theme: Theme) => ({
  restaurant: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'left',
    border: `${theme.palette.background.default} 1px solid`,
    minHeight: '60px',
    borderColor: darken(theme.palette.background.default, 0.2),
    '&:hover': {
      borderColor: theme.palette.secondary.main,
      boxShadow: `${theme.palette.secondary.main} -2px 2px 9px -5px`,
      backgroundColor: darken(theme.palette.background.default, 0.03)
    },
    '&:active': {
      borderColor: theme.palette.secondary.main,
      boxShadow: `${theme.palette.secondary.main} -2px 2px 9px -5px`,
      backgroundColor: darken(theme.palette.background.default, 0.1)
    },
    ...(theme.palette.type === 'dark'
      ? {
          borderColor: lighten(theme.palette.primary.main, 0.1),
          '&:hover': {
            background: 'transparent',
            borderColor: theme.palette.secondary.main,
            boxShadow: 'none'
          },
          '&:active': {
            background: lighten(theme.palette.background.default, 0.2),
            borderColor: theme.palette.secondary.main,
            boxShadow: `${theme.palette.secondary.main} -2px 2px 9px -5px`
          }
        }
      : {})
  },
  gutters: {
    paddingLeft: 0,
    paddingRight: 0
  },
  secondary: {
    margin: 0,
    backgroundColor: 'transparent'
  },
  restaurantDetails: {
    width: '100%',
    padding: '15px 20px 15px 15px'
  },
  description: {
    display: 'flex',
    alignItems: 'center'
  }
}));

export interface ListItemConcessionStoreProps {
  store: Api.ConcessionStore;
  summary: Api.CollectionRestaurantSummary;
}

type Props = ListItemConcessionStoreProps;

const ListItemConcessionStore: React.FC<Props> = props => {
  const { summary, store } = props;
  const [logoError, setLogoError] = useState<Error>();

  const classes = useStyles({});

  return (
    <ListItemLink
      key={store.ConcessionStoreId}
      to={
        '/restaurant/' +
        summary.VirtualRestaurantId +
        '/collection/' +
        summary.PhysicalRestaurantId +
        '/' +
        store.ConcessionStoreId
      }
      fdKey={`${store.ConcessionStoreId}`}
      className={classes.gutters}
    >
      <div
        key={`delivery-${store.ConcessionStoreId}`}
        className={classes.restaurant}
      >
        {logoError || !store.ImageUrl ? (
          ''
        ) : (
          <img
            onError={error => {
              setLogoError(new Error());
            }}
            src={`${store.ImageUrl}?w=120&h=120`}
            srcSet={`${store.ImageUrl}?w=120&h=120 1x, ${store.ImageUrl}?w=120&h=120&dpr=2 2x, ${store.ImageUrl}?w=120&h=120&dpr=3 3x`}
            alt=""
          />
        )}
        <div className={classes.restaurantDetails}>
          <Typography
            variant="h3"
            color="primary"
            className={classes.secondary}
          >
            {store.Name}
          </Typography>
          <div className={classes.description}>
            <Typography variant="h4" color="textPrimary">
              {store.Description}
            </Typography>
          </div>
        </div>
      </div>
    </ListItemLink>
  );
};

export default ListItemConcessionStore;
